module.exports = __webpack_public_path__ + "img/grad.4c4bd8d7.svg";